import styled from 'styled-components'
import { t } from 'ttag'
import { useQuery } from 'react-query'
import PropTypes from 'prop-types'

import { api } from '@h2/api'
import { Heading } from '@h2/components/typography/heading'
import { Skeleton } from '@h2/components/loading/skeleton'

import { ActivtyList } from './activityList'

import { fetchingStyles } from '../fetchingStyles'

const Wrap = styled.div`
  grid-area: act;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 5px;
  padding: 12.5px;
  flex-grow: 1;
  ${fetchingStyles}

  > p {
    padding: 20px;
  }
`
const RecentActivity = ({ numPerPage }) => {
  const { data: activityItems, isFetching } = useQuery(
    ['careerhub-feed', numPerPage],
    () => {
      return api.fetch(`/careerhub?num=${numPerPage}`, { method: 'GET' })
    }
  )

  if (isFetching) {
    return (
      <Wrap isFetching={isFetching}>
        <Skeleton height="145px" />
      </Wrap>
    )
  }

  return (
    <Wrap>
      <Heading level="4" mb="5px">
        {t`Recent activity`}
      </Heading>
      <ActivtyList items={activityItems} />
    </Wrap>
  )
}

RecentActivity.propTypes = {
  numPerPage: PropTypes.number
}

export { RecentActivity }
